module.exports = __webpack_public_path__ + "mainassets/img/gallery-close.449f4c5a.svg";